import {
  ConfigFormItem,
  getWidgetProps,
  RichTextAdvancedRender,
} from '@framework/engine';
import type { IWidgetComponentProps } from '@framework/engine';
import { StaticInput } from '@framework/form';
import { Button } from 'antd';
import { FullWidthCompact } from './CandidateWidgetComponent';
import { CandidateWidgetContainer } from './CandidateWidgetContainer';
import { getDinamicButtonProps } from './getModalButtoProps';
import type { ICandidateWidget } from './ICandidateWidget';

export interface ICandidateWidgetPreviewProps
  extends IWidgetComponentProps<ICandidateWidget> {}

export function CandidateWidgetPreview(props: ICandidateWidgetPreviewProps) {
  const options = getWidgetProps(props);

  const { buttonText, icon } = getDinamicButtonProps(
    props.widget.buttonText,
    props.widget.buttonTextAfter,
    false,
  );

  return (
    <CandidateWidgetContainer
      panelTitle={props.widget.panelTitle}
      showPanel={props.widget.showPanel}
    >
      <ConfigFormItem
        name={'string'}
        label={<RichTextAdvancedRender inline text={options.label} />}
        help={<RichTextAdvancedRender inline text={options.helpText} />}
        layout={{ hideVisualLabel: options.hideLabel }}
        readonly={options.readonly}
      >
        <FullWidthCompact>
          <StaticInput
            value={''}
            placeholder={options.placeholder}
            loading={false}
          />
          <Button size="large" type="primary" style={{ flex: 0 }} icon={icon}>
            {buttonText}
          </Button>
        </FullWidthCompact>
      </ConfigFormItem>
    </CandidateWidgetContainer>
  );
}
